import React from 'react';

export const pageMeta = {
  "name": "AJAX Examples",
  "link": "/javascript/ajax/examples"
};

export default function JavascriptAjaxExamples() {
  return (
    <div className="p-6 max-w-3xl mx-auto">
      <h2 className="text-2xl font-semibold mb-2">AJAX Examples</h2>
      <p>Route: /javascript/ajax/examples</p>
      <h3 className="mt-4 font-medium">sub_content</h3>
      <pre>{JSON.stringify(pageMeta, null, 2)}</pre>
    </div>
  );
}
